<!--首页 未绑定的考级中心 详情-->
<template>
  <div class="gray-back kaoji-box" style="padding:.2rem 0 1rem 0 ;  height: 100%">

    <div class="kaoji-title">{{ row.danwei }}{{ row.kaojitype }}</div>

    <van-cell-group>
      <div class="kaoji-img">
        <img :src="row.pic_url" alt="" style="width: 100%">
      </div>
      <van-cell title="考级单位名称" :value="row.danwei"></van-cell>
      <van-cell title="考级单位级别" :value="row.bgrade"></van-cell>
      <van-cell title="考级单位地址" :value="row.address"></van-cell>
      <van-cell title="客服电话" :value="row.contactsphone"></van-cell>
      <div style="height: 10px"></div>

    </van-cell-group>

    <div class="savebtn">
      <van-button
          v-if="row.is_join"
          style="width: 6rem" 
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          size="normal" round  >您已经是该俱乐部的成员
      </van-button>

      <van-button
          v-else
          style="width: 6rem"
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          size="normal" round @click="userShow=true">绑定为我的俱乐部
      </van-button>
    </div>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    <van-popup
        position="bottom"
        :style="{ height: '50%' }"
        v-model="userShow"
        @click-overlay="addShow=false"
    >
      <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
        <van-form
            @submit="submit"
            @failed="onFailed"
        >
          <van-divider>请输入联系人{{row.contactsname}}的身份证号码进行验证</van-divider>
          <van-cell-group> 

            <van-field 
                v-model="formData.num"
                :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                error-message-align="right"
                :label="row.contactsname+'的身份证号'"
                input-align="right"
                clearable
                placeholder="请输入身份证号"
            />
 

          </van-cell-group>

          <div class="savebtn">
            <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                native-type="submit">确认绑定
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
.kaoji-box .van-cell__value {
  color: #323233;
}

.kaoji-title {
  padding: .3rem;
  font-size: 24px;
  text-align: center;
}

.kaoji-mine {
  padding: 0 .3rem .4rem;
}

.bottom-img {
  text-align: center;
  margin-top: .3rem;
}

.bottom-img img {
  width: 5rem;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubDetailUnbind',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      userShow:false,
      submitType: '',
      id: 0,
      row: {},
      formData: {
        id: 0,
        name:'',
        num:'',
        password:'',
        areas:'',
        nprovince:'',
        ncity:'',
        ncounty:'',
        province:'',
        city:'',
        county:'',
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.id = this.$route.query.id;
    document.title = "俱乐部详情"
    that.fetch();

  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/club/clubDetail', {
        id: that.id,
      }, (res) => {
        that.areaValue = res.data.province + ' ' + res.data.city + ' ' + res.data.county
        that.row = res.data;
        that.formData.id = that.row.id
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    },

    submit() {
      let that = this
      that.$api.post('/api/club/clubUserBind', {
        club_id: that.id,
        num: that.formData.num
      }, (res) => {
        that.saveLoading = false;
        Toast.success('绑定成功')

        rbLink({
          name:'ClubSearchIndex',
        },'back')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },
    onFailed(){

    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// ClubDetailUnbind.vue?1ec70ef4